import {
  ColorClassnameMap,
  VariantClassnameMap,
  GradientBorderClassnameMap,
} from './types';

export const variantClassname: VariantClassnameMap = {
  text: 'disabled:opacity-30',
  outlined: 'disabled:opacity-30',
  contained: 'text-white disabled:opacity-30',
};

export const colorClassname: ColorClassnameMap = {
  info: {
    text: 'text-cyan-500 hover:bg-cyan-50',
    contained: 'bg-cyan-500 hover:bg-cyan-600',
    outlined: 'border-cyan-500 text-cyan-500 hover:bg-cyan-50',
  },
  success: {
    text: 'text-green-500 hover:bg-green-50',
    contained: 'bg-green-500 hover:bg-green-600',
    outlined: 'border-green-500 text-green-500 hover:bg-green-50',
  },
  secondary: {
    text: '',
    outlined: '',
    contained:
      'bg-accent-gradient-secondary-primary hover:bg-accent-gradient-secondary-hover active:bg-accent-gradient-secondary-active',
  },
  error: {
    text: 'text-red-primary hover:bg-red-50',
    outlined: 'border-red-300 text-red-400 hover:bg-red-50',
    contained:
      'text-white bg-red-primary-primary hover:bg-red-primary-hover active:bg-red-primary-active',
  },
  warning: {
    text: 'text-yellow-500 hover:bg-yellow-50',
    outlined: 'border-yellow-500 text-yellow-500 hover:bg-yellow-50',
    contained:
      'text-red-primary active:text-white bg-red-secondary-primary hover:bg-red-secondary-hover active:bg-red-secondary-active',
  },
  primary: {
    contained:
      'bg-accent-gradient-primary hover:bg-accent-gradient-hover active:bg-accent-gradient-active',
    text: 'bg-clip-text text-transparent bg-accent-gradient-primary hover:bg-accent-gradient-hover active:bg-accent-gradient-active',
    outlined:
      'bg-white-primary hover:bg-white-hover active:bg-white-active h-[46px] px-[15px] py-[11px] rounded-[calc(var(--radius-2xl)-1px)] [&>span]:bg-clip-text [&>span]:text-transparent [&>span]:bg-accent-gradient-primary transition-none',
  },
};

export const gradientBorderClassname: GradientBorderClassnameMap = {
  primary: {
    outlined: 'p-px bg-accent-gradient-primary rounded-2xl h-12',
  },
};
